import './vendors';
import { loadClass } from './loadClass';
import { imageViewerModal } from './wool/imageViewerModal';
import { selectpicker } from './wool/selectpicker';
import { utils } from './utils';

let NS = 'AWIWOOL';
window[NS] = {};

$(document).ready(() => {
	// IE is not supported based on https://levogroup.atlassian.net/browse/AWIS-239
	// if it's IE, it will show modal and doesn't need to initiate widgets, blocks, or pages
	if(document.documentMode) {
		$('.unsupportedBrowserModalWidget').addClass('d-block');
		$('.tpl').hide();
		$('body').css('overflow', 'hidden');
		return;
	}

	// Widgets
	loadClass('siteHeaderWidget', 'widget');
	loadClass('siteHeaderTopWidget', 'widget');
	loadClass('siteHeaderMicronWidget', 'widget');
	loadClass('siteHeaderBottomWidget', 'widget');
	loadClass('siteHeaderBottomSearchBarWidget', 'widget');
	loadClass('siteHeaderBottomMenuWidget', 'widget');
	loadClass('siteHeaderBottomSubMenuWidget', 'widget');
	loadClass('siteHeaderBottomSubMenuItemsWidget', 'widget');
	loadClass('siteFooterWidget', 'widget');
	loadClass('siteFooterGrowerToolsWidget', 'widget');
	loadClass('siteFooterLinksWidget', 'widget');
	loadClass('siteFooterSitemapWidget', 'widget');
	loadClass('siteEmailSubscribeWidget', 'widget');
	loadClass('bookmarkSquareWidget', 'widget');
	loadClass('siteHeroWidget', 'widget');
	loadClass('podcastListItemWidget', 'widget');
	loadClass('podcastsListingWidget', 'widget');
	loadClass('podcastLandingListItemWidget', 'widget');
	loadClass('podcastLandingListWidget', 'widget');
	loadClass('currentPodcastWidget', 'widget');
	loadClass('sidebarItemsWidget', 'widget');
	loadClass('sidebarWidget', 'widget');
	loadClass('mediaItemWidget', 'widget');
	loadClass('australianMapWidget', 'widget');
	loadClass('publicationListingItemWidget', 'widget');
	loadClass('marketReportsListingItemWidget', 'widget');
	loadClass('personalisedDashboardWidget', 'widget');
	loadClass('searchResultItemWidget', 'widget');
	loadClass('hubFilterBoxWidget', 'widget');
	loadClass('hubItemWidget', 'widget');
	loadClass('woolHeaderWidget', 'widget');
	loadClass('woolFooterWidget', 'widget');
	loadClass('woolPublicationListingItemWidget', 'widget');
	loadClass('woolMarketReportsListingItemWidget', 'widget');
	loadClass('mmfsSiteHeaderWidget', 'widget');
	loadClass('mmfsFilterBoxWidget', 'widget');
	loadClass('mmfsResourcesItemWidget', 'widget');

	// Blocks
	loadClass('videoModalBlock', 'block');
	loadClass('tabContainerBlock', 'block');
	loadClass('carouselBlock', 'block');
	loadClass('newsletterRegistrationBlock', 'block');
	loadClass('homePageCarouselBlock', 'block');
	loadClass('videoArticleBlock', 'block');
	loadClass('videoArticleListBlock', 'block');
	loadClass('wysiwygBlock', 'block');
	loadClass('personBioBlock', 'block');
	loadClass('accordionBlock', 'block');
	loadClass('chartBlock', 'block');
	loadClass('tableBlock', 'block');
	loadClass('marketSummaryBlock', 'block');
	loadClass('marketSummaryMonthlyBlock', 'block');
	loadClass('marketSummaryChartBlock', 'block');
	loadClass('marketEmiChartBlock', 'block');
	loadClass('marketEmiTableBlock', 'block');
	loadClass('marketMicronPriceChartBlock', 'block');
	loadClass('marketMicronPriceTableBlock', 'block');
	loadClass('marketOfferingChartBlock', 'block');
	loadClass('marketOfferingTableBlock', 'block');
	loadClass('marketCurrencyMovementsChartBlock', 'block');
	loadClass('marketCurrencyMovementsTableBlock', 'block');
	loadClass('marketForecastChartBlock', 'block');
	loadClass('marketForecastTableBlock', 'block');
	loadClass('fooLibraryBlock', 'block');
	loadClass('listingContainer', 'block');
	loadClass('listingContainerList', 'block');
	loadClass('woolHeroCarouselBlock', 'block');
	loadClass('woolNewsCarouselBlock', 'block');
	loadClass('woolEventsBlock', 'block');
	loadClass('woolArticleCarouselBlock', 'block');
	loadClass('woolMoreArticlesBlock', 'block');
	loadClass('woolBtbFeaturedBlock', 'block');
	loadClass('woolBtbInThisIssueBlock', 'block');
	loadClass('woolBtbRecentIssuesBlock', 'block');
	loadClass('australianMapBlock', 'block');
	loadClass('woolTimeriteBlock', 'block');
	loadClass('woolFlystrikeWheelBlock', 'block');
	loadClass('woolpollInteractiveGraphBlock', 'block');
	loadClass('mmfsAccordionBlock', 'block');
	loadClass('mmfsCarouselBlock', 'block');
	loadClass('mmfsDownloadPDFBtnBlock', 'block');
	loadClass('mmfsTileBlock', 'block');
	loadClass('chatbotBlock', 'block');

	// Pages
	loadClass('careerListingPage', 'page');
	loadClass('podcastListingPage', 'page');
	loadClass('publicationListingPage', 'page');
	loadClass('mediaListingPage', 'page');
	loadClass('articleDetailsPage', 'page');
	loadClass('searchResultPage', 'page');
	loadClass('projectListingPage', 'page');
	loadClass('hubSearchPage', 'page');
	loadClass('woolMediaListingPage', 'page');
	loadClass('woolPublicationListingPage', 'page');
	loadClass('woolEventListingPage', 'page');
	loadClass('woolMarketWeeklyReportsPage', 'page');
	loadClass('woolMarketReportsListingPage', 'page');
	loadClass('mmfsResourcesPage', 'page');
	loadClass('mmfsModulesDownloadPage', 'page');

	selectpicker();

	// init tooltips globally
	$('[data-toggle="tooltip"]').tooltip();

	// Init imageModalViewer
	imageViewerModal.init();

	utils.checkTheme();
	utils.locationPopup();

});
